export default __webpack_public_path__ + "media/images/ico-amazingservice-c2cd18a35ce7aa7a5485c78269a41f7e.svg";